
import React from 'react';
import './styledsk.css';
import logo from '../../assets/img/Sobr.png';
import couple from '../../assets/ambassadors/couple.png';
import world from '../../assets/ambassadors/world.png';
import asian2 from '../../assets/ambassadors/backgroundasian.png';
import arrow from '../../assets/img/arrow.svg';
import vector5 from '../../assets/ambassadors/Vector5.svg';
import midias from '../../assets/img/Social Media.svg';
import vector10 from '../../assets/ambassadors/vector10.svg';
import vector11 from '../../assets/ambassadors/Vector11.svg';
import vector12 from '../../assets/ambassadors/Vector12.svg';
import vector6 from '../../assets/img/Vector6.png';
import { useNavigate } from 'react-router-dom';



const Ambassadors = () => {

    const scrollToMenu = () => {
        const menuElement = document.querySelector('.logo2');
        if (menuElement) {
            menuElement.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
    <>
    <header className="header-containerx">
    <div className="header-left">
                <img className='logo2'src={logo} alt="Logo" height='70px' />
            </div>
            <nav className="header-nav">
                <a href="/br">Home</a>
                <a href="/embaixadores">Embaixadores</a>
                <a href="/timesobr">Time Sobr</a>
                <a href="/termosepolitica">Termos e Políticas</a>
            </nav>
            <div className="header-right">
            <a className='butontranslate' href="/">en-US</a>
            <a className='butontranslate' href="/es">es-ES</a>
            </div>
            <div className="header-right">
            </div>
        </header>
        <body>
                <div className="iphone4">
                    <main>
                    <section className="hero5">
                            <h1>Embaixadores Sobr</h1>
                            <p>Nossos Embaixadores Sobr são os corações e mentes por trás da revolução da felicidade na Sobr. Como defensores apaixonados pela sobriedade, eles personificam os valores de autenticidade, saúde e conexões genuínas que tornam a Sobr única.</p>                   
                            <button className="demo-button">BAIXE AGORA</button>
                    </section>
                    </main>
                </div>
                
                <div className="content11dsk">
                    <img className='match2' src={world} alt="match" title="match" height="500" />  
                    <section>       
                        <h1>O que fazem nossos Embaixadores</h1>
                        <p> <strong>Inspirar:</strong> Nossos embaixadores compartilham suas histórias pessoais de transformação e crescimento, inspirando outros a abraçarem a sobriedade como um estilo de vida positivo e gratificante.
<strong> Conectar: </strong>Eles são os construtores de pontes, unindo pessoas e comunidades em torno da missão da Sobr de criar um mundo mais feliz e saudável, livre do estigma associado à sobriedade.
<strong> Educar:</strong> Nossos embaixadores são educadores comprometidos, fornecendo recursos e informações valiosas sobre os benefícios da sobriedade e o apoio disponível na comunidade Sobr.</p>
                    </section>
                </div>
                <div className='div5'></div>
                <div className="content10dsk">
                <img className='asian2' src={asian2} alt="match" title="match" height="500" /> 
                </div>
                <div className='xxxx'>
                    <section>       
                        <h1>Por que se tornar um Embaixador:</h1>
                        <p> <strong>Impacto:</strong> Faça parte de uma comunidade global que está mudando vidas e desafiando as percepções sobre a sobriedade. Como embaixador, você terá a oportunidade de fazer uma diferença significativa na vida de outras pessoas.
<br></br> <strong>Suporte:</strong> Receba suporte da equipe Sobr e de outros embaixadores enquanto você navega em sua própria jornada de sobriedade e ajuda os outros em suas jornadas.
<strong>Reconhecimento:</strong> Seja reconhecido como um líder de pensamento e defensor da sobriedade, destacado em nossas plataformas e eventos, e faça parte de uma rede exclusiva de embaixadores globais.
                        </p>
                    </section>
                    </div>
{/* 
                <div className="content8dsk">
                    <h1>What our happy customers are saying</h1>
                </div>
                <div className='reviewsdsk'>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                <div className="review-boxdsk">
                    <div className="header2dsk">
                        <h3>Margie V.</h3>
                        <p>Montevideo</p>
                    </div>
                    <div className="starxdsk">
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="star">&#9733;</span>
                        <span className="time">2 months ago</span>
                    </div>
                    <div className="contentdsk">
                        <p>This mobile application, known as Sobr, and any and all corresponding websites (collectively referred to as the "App") are operated by Sobr</p>
                    </div>
                    <div className="verifieddsk">
                        <span>Verified by</span>
                    </div>
                </div>
                </div> */}
                <footer>
                    <div className="footer-contentdsk">
                        <p>Termos de Serviço | Política de Privacidade</p>
                    </div>
                    <div className="footer-copyrightdsk">
                    &copy; 2024 Sobr Inc., Todos os Direitos Reservados   
                    </div>
                    {/* Ícone da seta para rolar até o menu principal */}
                    <div onClick={scrollToMenu} style={{ cursor: 'pointer', marginTop: '20px' }}>
                        <img src={arrow} height="24" width="24" alt="scroll to top" title="scroll to top" />
                    </div>
                </footer>

        </body>     
    </>
        );
    };
export default Ambassadors;
